export default __webpack_public_path__ + "static/sunburst-c1cb48dfbb3aff09392c5887046fea8f.png";